import template from './ordinacijaCreateEdit.html';
import swal from 'sweetalert';

class OrdinacijaEditController {
    constructor(DS, AppConfiguration, $state, logger) {
        this.$state = $state;
        this.logger = logger;
        this.Model = DS.definitions['Ordinacija'];
        this.view = AppConfiguration().getViewByEntityAndType('Ordinacija', 'CreateView');
    }

    $onInit() {
        this.pageTitle = `Izmjena ordinacije dentalne medicine ${this.item.naziv}`;
        this.pageDesc = 'Podaci o ordinaciji dentalne medicine';
        this.fields = this.view.fields();
    }

    submit(item) {
        const previousWindowKeyDown = window.onkeydown;
        this.Model.update(item.id, item)
            .then(response => {
                swal(
                    {
                        title: 'Zahvaljujemo',
                        text: 'Podaci su uspješno ažurirani',
                        type: 'success',
                        closeOnConfirme: true
                    },
                    () => {
                        window.onkeydown = previousWindowKeyDown;
                        this.$state.go('ordinacija.details', { id: response.id });
                    }
                );
            })
            .catch(error => {
                this.logger.error('Upsss', error.data);
            });
    }
}

OrdinacijaEditController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];

const OrdinacijaEditComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: OrdinacijaEditController,
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
};

export { OrdinacijaEditComponent };
export { OrdinacijaEditController };



// WEBPACK FOOTER //
// ./app/components/ordinacija/ordinacijaEdit.component.js